import { render, staticRenderFns } from "./ScanLogs.vue?vue&type=template&id=a37be678&"
import script from "./ScanLogs.vue?vue&type=script&lang=js&"
export * from "./ScanLogs.vue?vue&type=script&lang=js&"
import style0 from "./ScanLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports